import React, { ReactNode } from "react";
import Split from "react-split";
import { Button, Icon } from "src/components";
import styled from "styled-components";
import {theme} from 'src/config'

export interface ISplitViewProps {
  top:               ReactNode,
  bottom:            ReactNode,
  offset?:           string,
  direction?:        SplitViewDirection,
}

export type SplitRefType = {collapse: (idx: number) => void};
export type SplitViewDirection = 'horizontal' | 'vertical'

export const SplitView = React.forwardRef<SplitRefType, ISplitViewProps>((props: ISplitViewProps, ref) => {
  const [collapsedIdx, setCollapsedIdx] = React.useState<number>(null);

  React.useImperativeHandle(ref, () => ({
    collapse: (idx: number): void => setCollapsedIdx(idx)
  }));

  return (
    <Container offset={props.offset || "0px"} direction={props.direction}>
      <Split
        className   = "split"
        direction   = {props.direction}
        minSize     = {0}
        collapsed   = {collapsedIdx}
        onDragStart = {() => setCollapsedIdx(null)}
      >
        <TopContainer collapsedIdx={collapsedIdx} collapsed={collapsedIdx === 0} direction={props.direction}>
          {(collapsedIdx !== 0 && false) && 
          <Button className="collapse-btn bottom" variant="icon" color="black">
            <Icon iconId="chevronDown" color="black" size="large" />
          </Button>
          }
          {props.top}
        </TopContainer>
        <BottomContainer collapsedIdx={collapsedIdx} direction={props.direction}>
          {(collapsedIdx !== 1 && false) && 
            <Button className="collapse-btn" variant="icon" color="black">
              <Icon iconId="chevronDown" color="black" size="large" />
            </Button>
          }
          {props.bottom}
        </BottomContainer>
      </Split>
    </Container>
  );
});


const TopContainer = styled.div<{collapsedIdx: number, collapsed?: boolean, direction?: SplitViewDirection }>`
  position:       relative;
  overflow:       hidden;
  overflow-y:     hidden;
  padding-top:    ${props => props.collapsed ? undefined : "3rem"};
  transition:     ${props => props.collapsedIdx != null ? "height 0.2s ease-in-out" : "padding-top 0.2s ease-in-out"};
  display:        flex;
  flex-direction: column;
  z-index:        1;
`;

const BottomContainer = styled(TopContainer)`
  background-color: ${theme.color.white};
  overflow-y: auto;
`;


const Container = styled.div<{offset: string, direction?: SplitViewDirection}>`
  height:   ${props => `calc(100vh - ${props.offset})`};
  overflow: hidden;

  .collapse-btn {
    position:  absolute;
    top:       ${({direction}) => `${direction == 'horizontal' ? '48.8%' : '0'}`};
    z-index:   1;
    left:      ${({direction}) => `${direction == 'horizontal' ? '0%' : '50%'}`};
    transform: ${({direction}) => `${direction == 'horizontal' ? 'rotate(90deg)' : 'translateX(-30%)'}`}; 
    
    &.bottom {
      top:       unset;
      bottom:    0;
      transform: translateX(-30%) rotate(180deg);
    }
  }
  .gutter {
    background-color:    ${theme.color.splitViewGutter};
    background-repeat:   no-repeat;
    background-position: 50%;
    border-top-left-radius: ${({direction}) => `${direction == 'horizontal' ? '15px' : '0p'}`};
    border-bottom-left-radius: ${({direction}) => `${direction == 'horizontal' ? '15px' : '0p'}`};
  }
  .gutter-horizontal,.gutter-vertical {
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=');
      cursor: ${({direction}) => `${direction == 'horizontal' ? 'col-resize' : 'row-resize'}`};
  }
  .split {
    -webkit-box-sizing: border-box;
    -moz-box-sizing:    border-box;
    box-sizing:         border-box;
    height:             100%;
    display:            ${({direction}) => `${direction == 'horizontal' ? 'flex' : 'block'}`};
  }
`;